import { isTableType } from 'constants/chart-roles';
import {
  TableItemCellRenderer,
  TableTotalCellRenderer,
} from 'components/table-item';

/**
 * Adds our custom cell renderer to every cell in the table and also
 * correctly configures the component so AgGrid can use it
 * @param {Object} stageData - object which contains a table spec, as well as environment information about chartType
 * @returns {Object} returns the new stage with the updated table spec
 */
function setTableCellRenderer(stageData) {
  const {
    spec,
    environment: { chartType },
  } = stageData;

  if (!isTableType(chartType)) {
    return {};
  }

  const { gridOptions = {} } = spec;

  const { frameworkComponents } = gridOptions;
  const columnDefs = spec.columnDefs.map(column => ({
    ...column,
    cellRenderer: 'tableItemCellRenderer',
    pinnedRowCellRenderer: 'tableTotalCellRenderer',
  }));

  const updatedSpec = {
    ...spec,
    columnDefs,
    gridOptions: {
      ...gridOptions,
      frameworkComponents: {
        ...frameworkComponents,
        tableItemCellRenderer: TableItemCellRenderer,
        tableTotalCellRenderer: TableTotalCellRenderer,
      },
    },
  };

  return { spec: updatedSpec };
}

export default {
  input: ['spec', 'environment.chartType'],
  fn: setTableCellRenderer,
};
export { setTableCellRenderer };
